export const background = 0;
export const aboveBackground = 1;
export const popup = 4;
export const modal = 99;
